import { useQuery } from "@tanstack/react-query";
import { fetchRestaurantsFromFirebase } from "../utils/restaurantService";
import { Restaurant } from "../types/restaurant";

/**
 * Custom hook to fetch and cache restaurant data using React Query
 *
 * Benefits:
 * - Automatic caching (5 minutes stale time, 10 minutes cache time)
 * - Reduces Firebase API calls
 * - Automatic background refetching
 * - Loading and error states handled
 * - Data persists across page navigations
 */
export const useRestaurants = () => {
  return useQuery<Restaurant[], Error, Restaurant[]>({
    queryKey: ["restaurants"],
    queryFn: fetchRestaurantsFromFirebase,
    staleTime: 5 * 60 * 1000, // Data is fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // Garbage collection time (formerly cacheTime)
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    retry: 2, // Retry failed requests twice
  });
};
